import * as ng from 'angular';

import {GuestType, GuestTypeService} from './guest-type.service';

const guestTypeEditUrl = require('./guest-type-edit.html');

export class GuestTypesController implements ng.IController {
   static $inject = ['titleService', 'GuestTypeService', 'session', 'dialogs', '$uibModal', 'loader'];

   guestTypes:GuestType[];

   constructor(
      private titleService,
      private guestTypeService:GuestTypeService,
      private session,
      private dialogs,
      private $uibModal,
      private loader
   ) {
      this.titleService.setTitle('Guest Types');
      this.activate();
   }

   activate() {
      this.loader.showSpinner();
      return this.guestTypeService.list(this.session.getCampaign().id)
         .finally(() => this.loader.hide())
         .then((guestTypes:GuestType[]) => {
            this.guestTypes = guestTypes;
         });
   }

   add():void {
      this.edit({
         id: 0,
         campaignId: this.session.getCampaign().id,
         name: null,
         slug: null,
         settings: { color: null }
      });
   }

   edit(guestType?:GuestType):void {
      this.$uibModal.open({
         templateUrl: guestTypeEditUrl,
         controller: 'GuestTypeEditController as vm',
         resolve: {
            guestType: ng.copy(guestType)
         }
      }).result.then(() => {
         this.activate();
      });
   }

   delete(guestType:GuestType):void {
      let message = `Are you sure you want to delete the guest type ${guestType.name}?`;
      this.dialogs.confirm(message).then(() => {
         this.loader.showSpinner();
         this.guestTypeService.delete(guestType.id, false)
            .then(() => this.activate())
            .finally(() => this.loader.hide())
            .catch(resp => {
               if (resp.status != 409) {
                  return resp;
               }

               let associations = [];

               if (resp.data.participantCount > 0) {
                  let s = resp.data.participantCount > 1 ? 's' : '';
                  associations.push(`${resp.data.participantCount} participant${s}`);
               }

               if (resp.data.preRegistrationCount > 0) {
                  let s = resp.data.preRegistrationCount > 1 ? 's' : '';
                  associations.push(`${resp.data.preRegistrationCount} pre-registration${s}`);
               }

               if (resp.data.inviteeCount > 0) {
                  let s = resp.data.inviteeCount > 1 ? 's' : '';
                  associations.push(`${resp.data.inviteeCount} invitee${s}`);
               }

               message = `This guest type has ${associations.join(', ')} associated with it and could not be deleted.`;

               if (this.session.isAdmin()) {
                  message += ' Deleting the guest type will clear the guest type for these guests.';
                  message += ' Press OK if you\'re sure you would like to delete this guest type.';

                  return this.dialogs.confirm(message).then(() => {
                     return this.guestTypeService.delete(guestType.id, true)
                        .then(() => this.activate());
                  });
               } else {
                  message += ' Please contact your administrator for assistance.';
                  this.dialogs.alert(message);
               }
            });
      });
   }
}

ng.module('e360')
   .controller('GuestTypesController', GuestTypesController);
